export const default_headers = {
    "Content-Type": "application/json",
    "Accept": "application/json"
  };
